<template>
  <div class="smartphone-site-menu">
    <div class="top-line">
      <div class="address-info">
        <b>Санкт-Петербург:</b><br/>
        <span class="addresses">Ул Оптиков 51/1,<br/>Ул Достоевского 6,<br/>Наб Реки Фонтанки 92</span>
      </div>
      <div class="time-info">
        <span class="label">Доставляем еду</span><br/>
        с 10:00 до 2:00
      </div>
    </div>
    <router-link :to="{ name: 'Conditions' }" class="site-link" active-class="active" @click.native="$emit('clickLink')">Доставка и оплата</router-link>
    <router-link :to="{ name: 'Restaurants' }" class="site-link" active-class="active" @click.native="$emit('clickLink')">Рестораны</router-link>
<!--    <router-link :to="{ name: 'About' }" class="site-link" active-class="active" @click.native="$emit('clickLink')">О доставке</router-link>-->
    <router-link :to="{ name: 'Index' }" class="site-link" active-class="active" @click.native="$emit('clickLink')">Меню</router-link>
    <smartphone-categories @clickCategory="$emit('clickLink')" @clickLink="$emit('clickLink')" :hideTitle="true" />
  </div>
</template>

<script>
  import SmartphoneCategories from '/src/blocks/SmartphoneCategories'

  import { mapGetters } from 'vuex'

  export default {
    name: 'SmartphoneSiteMenu',
    components: {
      SmartphoneCategories
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters({
        categories: 'menu/categories'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/SmartphoneSiteMenu.vue